<template>
    <div class="flex flex-col gap-4 p-4 md:p-10 md:pt-5 max-w-[718px]">
        <BaseCarousel v-model="activeId" :item-ids="itemIds">
            <template #item-1>
                <p class="body-small mb-4">{{ t("components.calendar.featureCarousel.slide1") }}</p>
                <img :src="CalendarIntegrationExample" :alt="t('components.calendar.featureCarousel.slide1Alt')" class="w-[632px] mx-auto" />
            </template>
            <template #item-2>
                <p class="body-small mb-4">{{ t("components.calendar.featureCarousel.slide2") }}</p>
                <img :src="CalendarChatExample" :alt="t('components.calendar.featureCarousel.slide2Alt')" class="w-[632px] mx-auto" />
            </template>
            <template #item-3>
                <p class="body-small mb-4">{{ t("components.calendar.featureCarousel.slide3") }}</p>
                <img :src="CalendarSchedulingExample" :alt="t('components.calendar.featureCarousel.slide3Alt')" class="w-[632px] mx-auto" />
            </template>
        </BaseCarousel>
        <div class="sticky bottom-0 bg-white pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] flex justify-center">
            <BaseButton
                theme="primary"
                :size="tonalThemeEnabled ? 'sm' : undefined"
                class="w-full md:w-auto md:min-w-52"
                :class="{ 'body-small': !tonalThemeEnabled }"
                @click="$emit('connect')">
                {{ t("components.calendar.featureCarousel.connect") }}
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
import CalendarIntegrationExample from "~assets/calendar_feature_carousel_1.png";
import CalendarChatExample from "~assets/calendar_feature_carousel_2.png";
import CalendarSchedulingExample from "~assets/calendar_feature_carousel_3.png";
import BaseCarousel from "~vue/components/BaseCarousel.vue";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import BaseButton from "../BaseButton.vue";

const { t } = useI18n();

const itemIds = ["1", "2", "3"];
defineEmits(["connect"]);

// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.
const activeId = ref(null);
</script>
